import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenService } from '../../../services/Authen/authen.service';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent implements OnInit {

  constructor(
    private AuthenService: AuthenService,
    private Router: Router
  ) { }

  auth_data:any;
  items = [];
  pageOfItems: Array<any>;

  user_id: any;
  edit_username: any;
  edit_password: any;
  edit_fName: any;
  edit_lName: any;
  edit_eMail: any;
  edit_tel: any;
  edit_prefix: any;
  edit_role: any;

  ngOnInit(): void {
    this.auth_data = JSON.parse(localStorage.getItem("access_token"));
    this.get_user();
  }

  get_user() {
    this.AuthenService.GetUsersAll().subscribe(
      responce => {
        this.items = Array(responce.length).fill(0).map((x, i) => ({
          number: i + 1,
          id: responce[i].id,
          username: responce[i].username,
          password: responce[i].password,
          email: responce[i].email,
          fname: responce[i].fname,
          lname: responce[i].lname,
          role: responce[i].role,
          status: responce[i].status,
          tel: responce[i].tel,
          createBy: responce[i].createBy,
          createDate: responce[i].createDate,
          updateBy: responce[i].updateBy,
          updateDate: responce[i].updateDate,
          khet: responce[i].khet,
          province: responce[i].province,
        }));
      }
    );
    
  }

  onChangePage(pageOfItems: Array<any>) {
    this.pageOfItems = pageOfItems;
  }

  create_users_page(){
    this.Router.navigate(['/create-user'])
  }

  edit_user_page(index){
    sessionStorage.setItem("id", this.items[index]['id']);
    this.Router.navigate(['/edit-user'])
  }

}
